import React from "react";
import { connect } from "react-redux";

import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser,
        project: store.project

    };
})

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            members: [],

        };
        
        _.map(
            ["membersList"],
            fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }

    membersList(options = null) {
        const { loggedUser } = this.props;
        let fetchUrl = `/api/projects/${this.props.project.Selected.id}/members`;

        Axios.get(fetchUrl).then(c => {
            if (c && c.data) {
                const taskMemberOptions = _(c.data)
                    .filter(u => u.user)
                    .map(u => {
                        return {
                            fromOption: true,
                            value: u.user.id,
                            label: u.user["first-name"] + " " + u.user["last-name"],
                            avatar: u.user.avatar,
                            user_role: u.user.role,
                            user: u.user
                        };
                    })
                    .value();
                const members = taskMemberOptions.filter(f => f.value !== loggedUser.data.id)
                this.setState({ ...this.state, members: members })
            }
        })
    }

    render() {
        const { conversations, dispatch, loggedUser,isAdmin } = this.props;

        if( conversations.selected.id ) {
            const isAdminNotMember = isAdmin && conversations.selected.tagged_users.filter( u => u.linkId === loggedUser.data.id ).length === 0;
            const options = isAdminNotMember ? [ 
                { 
                    value: loggedUser.data.id, 
                    label: loggedUser.data.firstName + " " + loggedUser.data.lastName, 
                    avatar: loggedUser.data.avatar,
                    user_role: loggedUser.data.user_role,
                    user: loggedUser.data 
                }
            ] : this.state.members;
            
            const handleSelectMembers = (value) => {
                dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_ONLY", selected: {...conversations.selected, tagged_users: [...conversations.selected.tagged_users, {...value, fromOption: true}] } });
            }

            const handleRenderOption = value => {
                let userRole = "";
                if (Array.isArray(value.user_role) && value.user_role[0]) {
                    const role = value.user_role[0].role;
                    userRole = `${role.roleType || ""} ${role.role || ""}`.trim();
                } else if (typeof value.user_role === "string") {
                    userRole = value.user_role;
                } else if (typeof value.user_role === "object" && value.user_role !== null) {
                    userRole = value.user_role.roleType ? `${value.user_role.roleType} ${value.user_role.role}` : value.user_role.role || "";
                }

                return (
                    <div class="userOption">
                        <Avatar id={`optionUsers_${value.value}`}  disableTooltip={true} name={`${value.label}`} image={value.avatar !== "default.png" ? `/api/file/profile_pictures/${value.avatar}` : null} />
                        <div class="recipientOptionContainer">
                            <span>{value.label}</span>
                            <span>{userRole}</span>
                        </div>
                    </div>
                );
            }

            return (
                <div class="formContainer">
                    <Select 
                        isSearchable={true}
                        classes={{options: `recipientOptions conversationMemberOptions`}}
                        options={ options }
                        placeholder="Add Members"
                        onChange={ handleSelectMembers }
                        onOpen={ this.membersList }
                        renderOption={ handleRenderOption }
                        selected={ conversations.fields.to }
                        searchIcon={<i class="material-icons">search</i>}
                        isClose={ conversations.actionType === "formSubmit" }
                        showSelectedInInput={ false }
                        exclude={ conversations.selected.tagged_users.map( u => u.user.id )}
                    />
                </div>
            );
        }

        return null;
    }
}

export default Search;